import { AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {ApplicationInfoService, PdfService, UserService} from '../services';
import {SessionStorage} from 'ngx-webstorage';
import {RouteUtil} from '../utils';
import {ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router} from '@angular/router';
import {catchError, from, of, Subscription} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {MsAuthService} from '../module/ms-auth';
import {toSignal} from "@angular/core/rxjs-interop";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements AfterViewChecked, OnInit, OnDestroy {
    private changeDetector = inject(ChangeDetectorRef);
    private authService = inject(MsAuthService);
    private userService = inject(UserService);
    private router = inject(Router);
    private route = inject(ActivatedRoute);
    private pdfService = inject(PdfService);
    private readonly applicationInfoService = inject(ApplicationInfoService);


    public menuVisible = false;
    private routeChangedSubscription: Subscription;

    @SessionStorage() public readonly loadingSpinnerVisible: boolean;
    @SessionStorage() public readonly userHasLogin: boolean;

    constructor() {
        this.setMenuVisibility();
    }

    async ngOnInit() {
        this.setMenuVisibility();

        this.routeChangedSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.setMenuVisibility();
                this.pdfService.pageCleanupAfterPdfGeneration();
            }
        });
    }

    ngOnDestroy() {
        this.routeChangedSubscription.unsubscribe();
    }

    ngAfterViewChecked() {
        // Prevents ExpressionChangedAfterItHasBeenCheckedError
        this.changeDetector.detectChanges();
    }

    private setMenuVisibility(): void {
        this.menuVisible = RouteUtil.getRouteData<boolean>(this.getActivatedRouteSnapshot(), 'menuVisible', false);
    }

    private getActivatedRouteSnapshot(): ActivatedRouteSnapshot {
        const currentRoute = this.route.root.firstChild;
        return currentRoute && currentRoute.snapshot ? currentRoute.snapshot : undefined;
    }

    public logout() {
        this.authService.logout();
        this.userService.resetUserInfo();
    }

    public readonly info = toSignal(
        from(this.authService.isReady()).pipe(
            switchMap(() => this.applicationInfoService.getInfo()),
            catchError(() => of(null))
        ),
        {initialValue: null}
    );
}
